<template>
  <el-form
    key="capacity"
    ref="form"
    :model="info"
    :rules="rules"
    class="ca-form"
    hide-required-asterisk
    inline
    label-position="left"
    label-width="95px"
    size="mini"
  >
    <template v-if="type === 'driver'">
      <template v-if="info['driverProperty'] === 'transfer'">
        <el-form-item
          v-if="show.includes('mobile')"
          class="ca-form-item ca-form-item-100 flex"
          label="手机号"
          prop="mobile"
        >
          <span slot="label">
            手机号
            <i v-if="requires.includes('mobile')" class="_F36807">*</i>
          </span>
          <el-input
            v-if="from === 'detail'"
            v-model="info['mobile']"
            class="ca-input"
            disabled
            maxleng="11"
            placeholder="输入手机号"
            type="number"
          />
          <slot name="driverMobile" />
        </el-form-item>
        <slot name="123"></slot>
        <!-- <el-form-item v-if="from === 'detail'" class="ca-form-item" label="司机性质">
          <span slot="label">
            司机性质
            <i class="_F36807">*</i>
          </span>
          <el-select
            v-model="info['driverProperty']"
            class="ca-input"
            placeholder="请选择司机性质"
            @change="handleChange($event, 'driverProperty')"
          >
            <el-option label="外调" value="transfer">外调 </el-option>
            <el-option label="自有" value="own">自有 </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          v-if="show.includes('convoyInfoId') && from === 'detail'"
          class="ca-form-item ca-form-item-100"
          label="车队"
        >
          <span slot="label">
            车队<i v-if="requires.includes('convoyInfoId')" class="_F36807">*</i>
          </span>
          <el-select
            v-model="info['convoyInfoId']"
            :filter-method="onConvoyFilter"
            class="ca-input"
            filterable
            placeholder="请选择车队"
            @change="handleChange($event, 'convoyInfoId')"
            @visible-change="onConvoyVisible"
          >
            <el-option
              v-for="convoy in convoyList"
              :key="convoy.id * 1"
              :label="convoy.name"
              :value="convoy.id * 1"
            />
          </el-select>
        </el-form-item>
        <div class="ca-form-item-dividing-line"></div>
        <div class="ca-form-item-title">
          <div class="title-bg"></div>
          <span>身份证</span>
          <span class="tip">身份证信息请仔细核对，接单后身份证号不允许修改</span>
        </div>
        <div class="ca-form-item-photos">
          <el-form-item
            v-if="show.includes('identityPositiveImage')"
            class="ca-form-item-photos-one"
            prop="identityPositiveImage"
            @mouseenter.native="handleMouseenter('identityPositiveImage')"
            @mouseleave.native="handleMouseLeave"
          >
            <nf-upload-image-new
              ref="identityPositiveImageUpload"
              :previewList="previewList"
              :value="info.identityPositiveImage"
              imageType="identityPositiveImage"
              filePath="driver"
              @handleRemove="handleRemove('identityPositiveImage')"
              @handleUpload="handleUpload"
            >
              <div class="ca-form-item-photos-label">
                身份证人像面
                <i v-if="requires.includes('identityPositiveImage')" class="_F36807 font_16">*</i>
              </div>
            </nf-upload-image-new>
          </el-form-item>
          <el-form-item
            v-if="show.includes('identityReverseImage')"
            class="ca-form-item-photos-one"
            prop="identityReverseImage"
            @mouseenter.native="handleMouseenter('identityReverseImage')"
            @mouseleave.native="handleMouseLeave"
          >
            <nf-upload-image-new
              ref="identityReverseImageUpload"
              :previewList="previewList"
              :value="info.identityReverseImage"
              imageType="identityReverseImage"
              filePath="driver"
              @handleRemove="handleRemove('identityReverseImage')"
              @handleUpload="handleUpload"
            >
              <div class="ca-form-item-photos-label">
                身份证国徽面
                <span v-if="requires.includes('identityReverseImage')" class="_F36807 font_16"
                  >*</span
                >
              </div>
            </nf-upload-image-new>
          </el-form-item>
          <span class="multiple-text">ctrl+v粘贴证件，支持拖拽上传证件</span>
        </div>
        <el-form-item v-if="show.includes('name')" class="ca-form-item" label="姓名" prop="name">
          <span slot="label">
            姓名
            <i v-if="requires.includes('name')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['name']" class="ca-input" placeholder="请输入择姓名"></el-input>
        </el-form-item>
        <el-form-item
          v-if="show.includes('identityNumber')"
          class="ca-form-item"
          label="身份证号"
          prop="identityNumber"
        >
          <span slot="label">
            身份证号
            <i v-if="requires.includes('identityNumber')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['identityNumber']"
            class="ca-input"
            placeholder="请输入身份证号"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('identityValidityStart')"
          class="ca-form-item"
          label="起始时间"
          prop="identityValidityStart"
        >
          <span slot="label">
            起始时间
            <i v-if="requires.includes('identityValidityStart')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['identityValidityStart']"
            :picker-options="idStartPicker"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择起始时间"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('identityValidityEnd')"
          class="ca-form-item"
          label="终止时间"
          prop="identityValidityEnd"
        >
          <span slot="label">
            终止时间
            <i v-if="requires.includes('identityValidityEnd')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['identityValidityEnd']"
            :picker-options="idEndPicker"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择终止时间"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('identityAddress')"
          class="ca-form-item"
          label="地址"
          prop="identityAddress"
        >
          <span slot="label">
            地址
            <i v-if="requires.includes('identityAddress')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['identityAddress']" class="ca-input" placeholder="请输入地址" />
        </el-form-item>
        <el-form-item
          v-if="show.includes('identityLicenseAgency')"
          class="ca-form-item"
          label="签发机关"
          prop="identityLicenseAgency"
        >
          <span slot="label">
            签发机关
            <i v-if="requires.includes('identityLicenseAgency')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['identityLicenseAgency']"
            class="ca-input"
            placeholder="请输入签发机关"
          />
        </el-form-item>
        <div class="ca-form-item-dividing-line"></div>
        <div class="ca-form-item-title">
          <div class="title-bg"></div>
          <span>司机结算信息</span>
          <span
            v-if="
              (from == 'waybill' && whetherUpdateWaybill && whetherUpdateWaybill == 1) ||
              from === 'detail'
            "
            class="font_14 _445EBF font_400 margin-l-15 pointer"
            @click="handleDriverBank"
            >编辑收款信息</span
          >
        </div>
        <el-form-item
          v-if="show.includes('bankCard')"
          class="ca-form-item"
          label="卡号"
          prop="bankCard"
        >
          <span slot="label">
            卡号
            <i v-if="requires.includes('bankCard')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['bankCard']" class="ca-input" disabled placeholder="未设置" />
        </el-form-item>
        <el-form-item
          v-if="show.includes('supBank')"
          class="ca-form-item"
          label="开户总行"
          prop="supBank"
        >
          <span slot="label">
            开户总行
            <i v-if="requires.includes('supBank')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['supBank']" class="ca-input" disabled placeholder="未设置" />
        </el-form-item>
        <!-- <el-form-item v-if="show.includes('bank')" class="ca-form-item" label="开户行" prop="bank">
          <span slot="label">
            开户行
            <i v-if="requires.includes('bank')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['bank']" class="ca-input" disabled placeholder="未设置" />
        </el-form-item> -->
        <el-form-item
          v-if="show.includes('bankCardPhone')"
          class="ca-form-item"
          label="预留手机"
          prop="bankCardPhone"
        >
          <span slot="label">
            预留手机
            <i v-if="requires.includes('bankCardPhone')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['bankCardPhone']"
            class="ca-input"
            disabled
            placeholder="未设置"
          />
        </el-form-item>
        <div class="ca-form-item-dividing-line"></div>
        <div class="ca-form-item-title">
          <div class="title-bg"></div>
          <span>驾驶证</span>
        </div>
        <div class="ca-form-item-photos">
          <el-form-item
            v-if="show.includes('driverLicenseOriginalImage')"
            class="ca-form-item-photos-one"
            prop="driverLicenseOriginalImage"
            @mouseenter.native="handleMouseenter('driverLicenseOriginalImage')"
            @mouseleave.native="handleMouseLeave"
          >
            <nf-upload-image-new
              ref="driverLicenseOriginalImageUpload"
              :previewList="previewList"
              :value="info.driverLicenseOriginalImage"
              imageType="driverLicenseOriginalImage"
              filePath="driver"
              @handleRemove="handleRemove('driverLicenseOriginalImage')"
              @handleUpload="handleUpload"
            >
              <div class="ca-form-item-photos-label">
                驾驶证正页
                <i v-if="requires.includes('driverLicenseOriginalImage')" class="_F36807 font_16"
                  >*</i
                >
              </div>
            </nf-upload-image-new>
          </el-form-item>
          <el-form-item
            v-if="show.includes('driverLicenseDeputyImage')"
            class="ca-form-item-photos-one"
            prop="driverLicenseDeputyImage"
            @mouseenter.native="handleMouseenter('driverLicenseDeputyImage')"
            @mouseleave.native="handleMouseLeave"
          >
            <nf-upload-image-new
              ref="driverLicenseDeputyImageUpload"
              :previewList="previewList"
              :value="info.driverLicenseDeputyImage"
              imageType="driverLicenseDeputyImage"
              filePath="driver"
              @handleRemove="handleRemove('driverLicenseDeputyImage')"
              @handleUpload="handleUpload"
            >
              <div class="ca-form-item-photos-label">
                驾驶证副页
                <i v-if="requires.includes('driverLicenseDeputyImage')" class="_F36807 font_16"
                  >*</i
                >
              </div>
            </nf-upload-image-new>
          </el-form-item>
          <span class="multiple-text">ctrl+v粘贴证件，支持拖拽上传证件</span>
        </div>
        <el-form-item
          v-if="show.includes('driverNo')"
          class="ca-form-item"
          label="驾驶证号"
          prop="driverNo"
        >
          <span slot="label">
            驾驶证号
            <i v-if="requires.includes('driverNo')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['driverNo']" class="ca-input" placeholder="请输入驾驶证号" />
        </el-form-item>
        <el-form-item
          v-if="show.includes('driverLicenseType')"
          class="ca-form-item"
          label="准驾车型"
          prop="driverLicenseType"
        >
          <span slot="label">
            准驾车型
            <i v-if="requires.includes('driverLicenseType')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['driverLicenseType']"
            class="ca-input"
            placeholder="请输入准驾车型"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('driverLicenseAgency')"
          class="ca-form-item"
          label="发证机关"
          prop="driverLicenseAgency"
        >
          <span slot="label">
            发证机关
            <i v-if="requires.includes('driverLicenseAgency')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['driverLicenseAgency']"
            class="ca-input"
            placeholder="请输入发证机关"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('driverLicenseValidityStart')"
          class="ca-form-item"
          label="起始时间"
          prop="driverLicenseValidityStart"
        >
          <span slot="label">
            起始时间
            <i v-if="requires.includes('driverLicenseValidityStart')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['driverLicenseValidityStart']"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择起始时间"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('driverLicenseValidityEnd')"
          class="ca-form-item"
          label="终止时间"
          prop="driverLicenseValidityEnd"
        >
          <span slot="label">
            终止时间
            <i v-if="requires.includes('driverLicenseValidityEnd')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['driverLicenseValidityEnd']"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择终止时间"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <template v-if="show.includes('professionalNumber')">
          <div class="ca-form-item-dividing-line"></div>
          <div v-if="show.includes('professionalNumber')" class="ca-form-item-title">
            <div class="title-bg"></div>
            <span>从业资格证</span>
          </div>
          <div class="tip" style="margin: -5px 0 5px 0">
            提示：行驶证总质量低于4500KG的4米2以下的车型，不需要填写从业资格证
          </div>
        </template>
        <div class="ca-form-item-photos">
          <el-form-item
            v-if="show.includes('professionalImage')"
            class="ca-form-item-photos-one"
            prop="professionalImage"
            @mouseenter.native="handleMouseenter('professionalImage')"
            @mouseleave.native="handleMouseLeave"
          >
            <nf-upload-image-new
              ref="professionalImageUpload"
              :previewList="previewList"
              :value="info.professionalImage"
              imageType="professionalImage"
              filePath="driver"
              @handleRemove="handleRemove('professionalImage')"
              @handleUpload="handleUpload"
            >
              <div class="ca-form-item-photos-label">
                从业资格证
                <i v-if="requires.includes('professionalImage')" class="_F36807 font_16">*</i>
              </div>
            </nf-upload-image-new>
          </el-form-item>
          <span class="multiple-text">ctrl+v粘贴证件，支持拖拽上传证件</span>
        </div>
        <el-form-item
          v-if="show.includes('professionalNumber')"
          class="ca-form-item"
          label="资格证号"
        >
          <span slot="label">
            资格证号
            <i v-if="requires.includes('professionalNumber')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['professionalNumber']"
            class="ca-input"
            placeholder="请输入资格证号"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('professionalType')"
          class="ca-form-item"
          label="资格证类型"
          prop="professionalType"
        >
          <span slot="label">
            资格证类型
            <i v-if="requires.includes('professionalType')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['professionalType']"
            class="ca-input"
            placeholder="请输入资格证类型"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('professionalValidityStart')"
          class="ca-form-item"
          label="起始时间"
          prop="professionalValidityStart"
        >
          <span slot="label">
            起始时间
            <i v-if="requires.includes('professionalValidityStart')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['professionalValidityStart']"
            :picker-options="driverStartPicker"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择起始时间"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('professionalValidityEnd')"
          class="ca-form-item"
          label="终止时间"
          prop="professionalValidityEnd"
        >
          <span slot="label">
            终止时间
            <i v-if="requires.includes('professionalValidityEnd')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['professionalValidityEnd']"
            :picker-options="driverEndPicker"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择终止时间"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <div class="ca-form-item-dividing-line"></div>
        <div
          v-if="show.includes('vehicleNo') && from === 'detail' && info['id']"
          class="ca-form-item-title"
        >
          <div class="title-bg"></div>
          <span>绑定车辆</span>
        </div>
        <el-form-item
          v-if="show.includes('vehicleNo') && from === 'detail' && info['id']"
          class="ca-form-item"
          label="绑定车辆"
        >
          <span slot="label">
            绑定车辆
            <i v-if="requires.includes('vehicleNo')" class="_F36807">*</i>
          </span>
          <div
            class="flexCon font_14 margin-l-10 pointer margin-b-10"
            v-for="(item, index) in carList"
            :key="index"
            style="line-height: 30px"
          >
            <span class="font_500">
              <span class="_666666 font_400 set-vehicleNo"> {{ item.vehicleNo }} </span>
            </span>
            <nf-upload-file-base64
              class="avatar-uploader"
              :value="item.driverVehiclePicture"
              @change="handleUploadImage($event, item)"
              placeholder="人车合照"
            />
            <span
              @click="handleUnBandCar(item.vehicleInfoId)"
              class="unset-default margin-l-25"
              style="line-height: 30px"
            >
              解绑
            </span>
            <span
              v-if="item.isDefault !== 1"
              @click="setCarDefault(item.vehicleInfoId)"
              class="_445EBF margin-l-25"
              style="line-height: 30px"
            >
              设为默认
            </span>
            <span v-else class="set-default margin-l-25">默认</span>
          </div>
          <div class="bind" v-if="carList.length < 10">
            <el-autocomplete
              v-model="carValue"
              :debounce="0"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              class="ca-input"
              placeholder="绑定车辆"
              size="mini"
              value-key="name"
              @select="handleSelect"
            >
              <template slot-scope="{ item }">
                <el-tooltip
                  :content="
                    item.name ? item.name + ' ' + item.vehicleType + ' ' + item.vehicleColor : ''
                  "
                  class="item"
                  effect="dark"
                  placement="right"
                >
                  <div class="flexCon justify_space">
                    <span>
                      {{ item.name }}
                    </span>
                    <span class="_999999">
                      {{ item.vehicleColor }}
                    </span>
                  </div>
                </el-tooltip>
              </template>
            </el-autocomplete>
            <span
              class="font_14 margin-l-20 inline_block"
              style="width: 60px; line-height: 40px"
              :class="!carValue ? ' allowed _999999' : 'pointer _445EBF'"
              @click="carValue ? handBangDingCar(carValue) : null"
            >
              绑定
            </span>
          </div>
        </el-form-item>
        <div
          v-if="show.includes('vehicleNo') && from === 'detail' && info['id']"
          class="ca-form-item-dividing-line"
        />
        <div v-if="show.includes('collectInfoId') && from === 'detail'" class="ca-form-item-title">
          <div class="title-bg"></div>
          <span>默认收款人</span>
        </div>
        <el-form-item
          v-if="show.includes('collectInfoId') && from === 'detail'"
          class="ca-form-item"
          label="默认收款人"
        >
          <span slot="label">
            默认收款人
            <i v-if="requires.includes('collectInfoId')" class="_F36807">*</i>
          </span>
          <el-select
            :filter-method="onCaptainRemoteMethod1"
            v-model="info['collectInfoId']"
            class="ca-input"
            clearable
            filterable
            no-match-text="无匹配收款人"
            placeholder="选择默认收款人"
            size="small"
            style="width: 260px"
            @change="handleChange($event, 'collectInfoId')"
            @clear="handCaptainClear"
            @visible-change="onCaptainVisible1"
          >
            <el-option
              v-for="item in collectList"
              :key="item.id"
              :label="item.payeeName"
              :value="item.id * 1"
            >
              <div class="flexCon justify_space">
                <span class="_999999">
                  {{ item.payeeName }}
                </span>
                <span class="margin-l-20">
                  {{ item.bankName
                  }}<span v-if="item.payeeBankCardNo">{{
                    item.payeeBankCardNo.slice(item.payeeBankCardNo.length - 4)
                  }}</span>
                </span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="info['driverProperty'] === 'own'">
        <div class="ca-form-item-title">
          <div class="title-bg"></div>
          基础信息
        </div>
        <el-form-item class="ca-form-item" label="姓名" prop="name" required>
          <span slot="label">
            姓名
            <i class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['name']"
            class="ca-input"
            max-length="20"
            placeholder="请输入姓名"
          />
        </el-form-item>
        <el-form-item class="ca-form-item" label="姓名" prop="mobile" required>
          <span slot="label">
            手机号
            <i class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['mobile']"
            class="ca-input"
            disabled
            max-length="20"
            placeholder="请输入手机号"
          />
        </el-form-item>
        <!-- <el-form-item class="ca-form-item" label="司机性质" prop="driverProperty" required>
          <span slot="label">
            司机性质
            <i class="_F36807">*</i>
          </span>
          <el-select
            v-model="info['driverProperty']"
            class="ca-input"
            placeholder="请选择司机性质"
            @change="handleChange($event, 'driverProperty')"
          >
            <el-option label="外调" value="transfer">外调 </el-option>
            <el-option label="自有" value="own">自有 </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item class="ca-form-item" label="车队">
          <span slot="label"> 车队 </span>
          <el-select
            v-model="info['convoyInfoDto'].name"
            :filter-method="onConvoyFilter"
            class="ca-input"
            filterable
            placeholder="请选择车队"
            @change="handleChange($event, 'convoyInfoId')"
            @visible-change="onConvoyVisible"
          >
            <el-option
              v-for="convoy in convoyList"
              :key="convoy.id * 1"
              :label="convoy.name"
              :value="convoy.id * 1"
            />
          </el-select>
        </el-form-item>
        <template v-if="info && info.id">
          <div class="ca-form-item-title">
            <div class="title-bg"></div>
            日志
          </div>
          <el-form-item class="ca-form-item" label="创建人">
            <span slot="label"> 创建人 </span>
            <div class="ca-input _999999 font_14 padding-l-20">{{ info['creatorName'] }}</div>
          </el-form-item>
          <el-form-item class="ca-form-item" label="创建时间">
            <span slot="label"> 创建时间 </span>
            <div class="ca-input _999999 font_14 padding-l-20">{{ info['createTime'] }}</div>
          </el-form-item>
        </template>
      </template>
    </template>
    <template v-if="type === 'vehicle'">
      <div v-if="info['vehicleProperty'] === 'own'" class="ca-form-item-title">
        <div class="title-bg"></div>
        基础信息
      </div>
      <el-form-item
        v-if="show.includes('vehicleNo')"
        class="ca-form-item"
        label="车牌号"
        prop="vehicleNo"
        required
      >
        <span slot="label">
          车牌号
          <i v-if="requires.includes('vehicleNo')" class="_F36807">*</i>
        </span>
        <slot name="vehicleNo" />
        <el-input
          v-if="from === 'detail'"
          v-model="info['vehicleNo']"
          class="ca-input"
          :disabled="info['id']"
          maxleng="8"
          placeholder="输入车牌号"
        />
      </el-form-item>
      <!-- <el-form-item
        v-if="from === 'detail'"
        class="ca-form-item"
        label="车辆性质"
        prop="vehicleProperty"
        required
      >
        <span slot="label">
          车辆性质
          <i class="_F36807">*</i>
        </span>
        <el-select
          v-model="info['vehicleProperty']"
          class="ca-input"
          placeholder="请选择司机性质"
          @change="handleChange($event, 'vehicleProperty')"
        >
          <el-option label="外调" value="transfer">外调 </el-option>
          <el-option label="自有" value="own">自有 </el-option>
        </el-select>
      </el-form-item> -->
      <div>
        <el-form-item v-if="show.includes('vehicleModel')" label="车型" prop="vehicleModel">
          <span slot="label">
            车型
            <i v-if="requires.includes('vehicleModel')" class="_F36807">*</i>
          </span>
          <el-select multiple v-model="info['vehicleModel']" collapse-tags placeholder="请选择车型">
            <el-option
              v-for="item in VehicleModelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="ca-form-item" label="车长" prop="carryCargoLength">
          <span slot="label">
            车长<i v-if="requires.includes('carryCargoLength')" class="_F36807">*</i>
          </span>
          <el-select
            v-model="info['carryCargoLength']"
            class="ca-input popperClass"
            filterable
            placeholder="请选择车长"
          >
            <el-option
              v-for="even in extent"
              :key="even.value"
              :label="even.label | filterExtent"
              :value="even.value"
            >
              {{ even.label }} 米
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <template v-if="info['vehicleProperty'] === 'transfer'">
        <!-- 行驶证 -->
        <div class="ca-form-item-dividing-line"></div>
        <div class="ca-form-item-title">
          <div class="title-bg"></div>
          <span>行驶证</span>
        </div>
        <div class="ca-form-item-photos">
          <el-form-item
            v-if="show.includes('vehicleLicenseOriginalImage')"
            class="ca-form-item-photos-one"
            prop="vehicleLicenseOriginalImage"
            @mouseenter.native="handleMouseenter('vehicleLicenseOriginalImage')"
            @mouseleave.native="handleMouseLeave"
          >
            <nf-upload-image-new
              ref="vehicleLicenseOriginalImageUpload"
              :previewList="previewList"
              :value="info.vehicleLicenseOriginalImage"
              imageType="vehicleLicenseOriginalImage"
              filePath="vehicle"
              @handleRemove="handleRemove('vehicleLicenseOriginalImage')"
              @handleUpload="handleUpload"
            >
              <div class="ca-form-item-photos-label">
                行驶证正页
                <i v-if="requires.includes('vehicleLicenseOriginalImage')" class="_F36807 font_16"
                  >*</i
                >
              </div>
            </nf-upload-image-new>
          </el-form-item>
          <el-form-item
            v-if="show.includes('vehicleLicenseDeputyImage')"
            class="ca-form-item-photos-one"
            prop="vehicleLicenseDeputyImage"
            @mouseenter.native="handleMouseenter('vehicleLicenseDeputyImage')"
            @mouseleave.native="handleMouseLeave"
          >
            <nf-upload-image-new
              ref="vehicleLicenseDeputyImageUpload"
              :previewList="previewList"
              :value="info.vehicleLicenseDeputyImage"
              imageType="vehicleLicenseDeputyImage"
              filePath="vehicle"
              @handleRemove="handleRemove('vehicleLicenseDeputyImage')"
              @handleUpload="handleUpload"
            >
              <div class="ca-form-item-photos-label">
                行驶证副页
                <span v-if="requires.includes('vehicleLicenseDeputyImage')" class="_F36807 font_16"
                  >*</span
                >
              </div>
            </nf-upload-image-new>
          </el-form-item>
          <el-form-item
            v-if="show.includes('drivingPermitPhotosExtra')"
            :required="requires.includes('drivingPermitPhotosExtra')"
            class="ca-form-item-photos-one"
            prop="drivingPermitPhotosExtra"
            @mouseenter.native="handleMouseenter('drivingPermitPhotosExtra')"
            @mouseleave.native="handleMouseLeave"
          >
            <nf-upload-image-new
              ref="drivingPermitPhotosExtraUpload"
              :previewList="previewList"
              :value="info.drivingPermitPhotosExtra"
              imageType="drivingPermitPhotosExtra"
              filePath="vehicle"
              @handleRemove="handleRemove('drivingPermitPhotosExtra')"
              @handleUpload="handleUpload"
            >
              <div class="ca-form-item-photos-label">
                行驶证年检页
                <i v-if="requires.includes('drivingPermitPhotosExtra')" class="_F36807 font_16"
                  >*</i
                >
              </div>
            </nf-upload-image-new>
          </el-form-item>
          <span class="multiple-text">ctrl+v粘贴证件，支持拖拽上传证件</span>
        </div>
        <el-form-item
          v-if="show.includes('vehicleType')"
          class="ca-form-item"
          label="车辆类型"
          prop="vehicleType"
        >
          <span slot="label">
            车辆类型
            <i v-if="requires.includes('vehicleType')" class="_F36807">*</i>
          </span>
          <el-select
            v-model="info['vehicleType']"
            class="ca-input"
            filterable
            placeholder="请选择车辆类型"
          >
            <el-option
              v-for="convoy in vehicleTypeList"
              :key="convoy.value"
              :label="convoy.label"
              :value="convoy.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="show.includes('vehicleColor')"
          class="ca-form-item ca-form-item-100"
          label="车牌颜色"
          prop="vehicleColor"
        >
          <span slot="label">
            车牌颜色
            <i v-if="requires.includes('vehicleColor')" class="_F36807">*</i>
          </span>
          <el-radio-group v-model="info['vehicleColor']">
            <el-radio label="黄色" />
            <el-radio label="黄绿色" />
            <el-radio label="蓝色" />
            <el-radio label="渐变绿色" />
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="show.includes('fuelType')"
          class="ca-form-item ca-form-item-100"
          label="能源类型"
          prop="fuelType"
        >
          <span slot="label">
            能源类型
            <i v-if="requires.includes('fuelType')" class="_F36807">*</i>
          </span>
          <el-radio-group v-model="info['fuelType']">
            <el-radio label="柴油" />
            <el-radio label="天然气" />
            <el-radio label="汽油" />
            <el-radio label="新能源/电" />
            <el-radio label="液化石油气" />
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="show.includes('vehicleLength')"
          class="ca-form-item"
          label="外廓尺寸(长)"
          prop="vehicleLength"
        >
          <span slot="label">
            外廓尺寸(长)
            <i v-if="requires.includes('vehicleLength')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['vehicleLength']"
            class="ca-input"
            placeholder="请输入外廓尺寸(长)"
          >
            <template slot="append">毫米</template>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="show.includes('grossMass')"
          class="ca-form-item"
          label="总质量"
          prop="grossMass"
        >
          <span slot="label">
            总质量
            <i v-if="requires.includes('grossMass')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['grossMass']" class="ca-input" placeholder="输入总质量">
            <template slot="append"> kg</template>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="show.includes('vehicleWidth')"
          class="ca-form-item"
          label="外廓尺寸(宽)"
          prop="vehicleWidth"
        >
          <span slot="label">
            外廓尺寸(宽)
            <i v-if="requires.includes('vehicleWidth')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['vehicleWidth']"
            class="ca-input"
            placeholder="请输入外廓尺寸(宽)"
          >
            <template slot="append">毫米</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="show.includes('chassisNo')" class="ca-form-item" prop="chassisNo">
          <span slot="label">
            车架号
            <i v-if="requires.includes('chassisNo')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['chassisNo']" class="ca-input" placeholder="请输入车架号" />
        </el-form-item>
        <el-form-item
          v-if="show.includes('vehicleHigh')"
          class="ca-form-item"
          label="外廓尺寸(高)"
          prop="vehicleHigh"
        >
          <span slot="label">
            外廓尺寸(高)
            <i v-if="requires.includes('vehicleHigh')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['vehicleHigh']" class="ca-input" placeholder="请输入外廓尺寸(高)">
            <template slot="append">毫米</template>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="show.includes('approverLoad')"
          class="ca-form-item"
          label="核定载重"
          prop="approverLoad"
        >
          <span slot="label">
            核定载重
            <i v-if="requires.includes('approverLoad')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['approverLoad']" class="ca-input" placeholder="核定载重">
            <template slot="append"> kg</template>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="show.includes('totalTractionMass')"
          class="ca-form-item"
          label="牵引总量"
          prop="totalTractionMass"
        >
          <span slot="label">
            牵引总量
            <i v-if="requires.includes('totalTractionMass')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['totalTractionMass']"
            class="ca-input"
            oninput="value=value.match(/^\d*(\.?\d{0,2})/g)[0];"
            placeholder="牵引总量"
          >
            <template slot="append"> kg</template>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="show.includes('curbWeight')"
          class="ca-form-item"
          label="整备质量"
          prop="curbWeight"
        >
          <span slot="label">
            整备质量
            <i v-if="requires.includes('curbWeight')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['curbWeight']"
            class="ca-input"
            oninput="value=value.match(/^\d*(\.?\d{0,2})/g)[0];"
            placeholder="整备质量"
          >
            <template slot="append"> kg</template>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="show.includes('owner')"
          class="ca-form-item"
          label="所有人"
          prop="owner"
        >
          <span slot="label">
            所有人
            <i v-if="requires.includes('owner')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['owner']" class="ca-input" placeholder="请输入所有人"></el-input>
        </el-form-item>
        <el-form-item
          v-if="show.includes('vehicleLicenseAuthority')"
          class="ca-form-item"
          label="发证机关"
          prop="vehicleLicenseAuthority"
        >
          <span slot="label">
            发证机关
            <i v-if="requires.includes('vehicleLicenseAuthority')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['vehicleLicenseAuthority']"
            class="ca-input"
            placeholder="请输入发证机关"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('vehicleLicenseRegisterDate')"
          class="ca-form-item"
          label="注册日期"
          prop="vehicleLicenseRegisterDate"
        >
          <span slot="label">
            注册日期
            <i v-if="requires.includes('vehicleLicenseRegisterDate')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['vehicleLicenseRegisterDate']"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择注册日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('vehicleLicenseIssueDate')"
          class="ca-form-item"
          label="发证日期"
          prop="vehicleLicenseIssueDate"
        >
          <span slot="label">
            发证日期
            <i v-if="requires.includes('vehicleLicenseIssueDate')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['vehicleLicenseIssueDate']"
            :picker-options="idEndPicker"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择发证日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('natureUsage')"
          class="ca-form-item"
          label="使用性质"
          prop="natureUsage"
        >
          <span slot="label">
            使用性质
            <i v-if="requires.includes('natureUsage')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['natureUsage']" class="ca-input" placeholder="请输入使用性质" />
        </el-form-item>
        <el-form-item
          v-if="show.includes('cargoTonnage')"
          class="ca-form-item"
          label="载货质量"
          prop="cargoTonnage"
        >
          <span slot="label">
            载货质量
            <i v-if="requires.includes('cargoTonnage')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['cargoTonnage']" class="ca-input" placeholder="请输入载货质量" />
        </el-form-item>
        <el-form-item
          v-if="show.includes('drivingLicenseEndDate')"
          class="ca-form-item"
          label="有效期至"
          prop="drivingLicenseEndDate"
        >
          <span slot="label">
            有效期至
            <i v-if="requires.includes('drivingLicenseEndDate')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['drivingLicenseEndDate']"
            class="ca-input"
            type="month"
            format="yyyy年MM月"
            placeholder="请选择有效期至"
            value-format="yyyy-MM"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('drivingLicenseFileNumber')"
          class="ca-form-item"
          label="档案编号"
          prop="drivingLicenseFileNumber"
        >
          <span slot="label">
            档案编号
            <i v-if="requires.includes('drivingLicenseFileNumber')" class="_F36807">*</i>
          </span>
          <el-input
            v-model="info['drivingLicenseFileNumber']"
            class="ca-input"
            placeholder="请输入档案编号"
          />
        </el-form-item>
        <el-form-item
          v-if="show.includes('vehicleBrand')"
          class="ca-form-item"
          label="品牌型号"
          prop="vehicleBrand"
        >
          <span slot="label">
            品牌型号
            <i v-if="requires.includes('vehicleBrand')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['vehicleBrand']" class="ca-input" placeholder="请输入品牌型号" />
        </el-form-item>
        <el-form-item
          v-if="show.includes('engineNo')"
          class="ca-form-item"
          label="发动机号"
          prop="engineNo"
        >
          <span slot="label">
            发动机号
            <i v-if="requires.includes('engineNo')" class="_F36807">*</i>
          </span>
          <el-input v-model="info['engineNo']" class="ca-input" placeholder="请输入发动机号" />
        </el-form-item>
        <el-form-item
          v-if="show.includes('scrapDate')"
          class="ca-form-item"
          label="车辆报废日期"
          prop="scrapDate"
        >
          <span slot="label">
            车辆报废日期
            <i v-if="requires.includes('scrapDate')" class="_F36807">*</i>
          </span>
          <el-date-picker
            v-model="info['scrapDate']"
            class="ca-input"
            format="yyyy年MM月dd日"
            placeholder="请选择车辆报废日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <!-- 挂车行驶证 -->
        <template
          v-if="
            show.includes('trailerLicenseOriginalImage') ||
            show.includes('trailerLicenseDeputyImage') ||
            show.includes('trailerDrivingPermitPhotosExtra')
          "
        >
          <div class="ca-form-item-dividing-line"></div>
          <div class="ca-form-item-title">
            <div class="title-bg"></div>
            <span>挂车行驶证</span>
          </div>
          <div class="ca-form-item-photos">
            <el-form-item
              v-if="show.includes('trailerLicenseOriginalImage')"
              class="ca-form-item-photos-one"
              prop="trailerLicenseOriginalImage"
              @mouseenter.native="handleMouseenter('trailerLicenseOriginalImage')"
              @mouseleave.native="handleMouseLeave"
            >
              <nf-upload-image-new
                ref="trailerLicenseOriginalImageUpload"
                :previewList="previewList"
                :value="info.trailerLicenseOriginalImage"
                imageType="trailerLicenseOriginalImage"
                filePath="vehicle"
                @handleRemove="handleRemove('trailerLicenseOriginalImage')"
                @handleUpload="handleUpload"
              >
                <div class="ca-form-item-photos-label">
                  挂车行驶证正面
                  <i
                    v-if="
                      requires.includes('trailerLicenseOriginalImage') &&
                      info.vehicleType &&
                      info.vehicleType.includes('挂')
                    "
                    class="_F36807 font_16"
                    >*</i
                  >
                </div>
              </nf-upload-image-new>
            </el-form-item>
            <el-form-item
              v-if="show.includes('trailerLicenseDeputyImage')"
              class="ca-form-item-photos-one"
              prop="trailerLicenseDeputyImage"
              @mouseenter.native="handleMouseenter('trailerLicenseDeputyImage')"
              @mouseleave.native="handleMouseLeave"
            >
              <nf-upload-image-new
                ref="trailerLicenseDeputyImageUpload"
                :previewList="previewList"
                :value="info.trailerLicenseDeputyImage"
                imageType="trailerLicenseDeputyImage"
                filePath="vehicle"
                @handleRemove="handleRemove('trailerLicenseDeputyImage')"
                @handleUpload="handleUpload"
              >
                <div class="ca-form-item-photos-label">
                  挂车行驶证副页
                  <i
                    v-if="
                      requires.includes('trailerLicenseDeputyImage') &&
                      info.vehicleType &&
                      info.vehicleType.includes('挂')
                    "
                    class="_F36807 font_16"
                    >*</i
                  >
                </div>
              </nf-upload-image-new>
            </el-form-item>
            <el-form-item
              v-if="show.includes('trailerDrivingPermitPhotosExtra')"
              class="ca-form-item-photos-one"
              prop="trailerDrivingPermitPhotosExtra"
              @mouseenter.native="handleMouseenter('trailerDrivingPermitPhotosExtra')"
              @mouseleave.native="handleMouseLeave"
            >
              <nf-upload-image-new
                ref="trailerDrivingPermitPhotosExtraUpload"
                :previewList="previewList"
                :value="info.trailerDrivingPermitPhotosExtra"
                imageType="trailerDrivingPermitPhotosExtra"
                filePath="vehicle"
                @handleRemove="handleRemove('trailerDrivingPermitPhotosExtra')"
                @handleUpload="handleUpload"
              >
                <div class="ca-form-item-photos-label">
                  挂车行驶证年检页
                  <i
                    v-if="
                      requires.includes('trailerDrivingPermitPhotosExtra') &&
                      info.vehicleType &&
                      info.vehicleType.includes('挂')
                    "
                    class="_F36807 font_16"
                    >*</i
                  >
                </div>
              </nf-upload-image-new>
            </el-form-item>
            <span class="multiple-text">ctrl+v粘贴证件，支持拖拽上传证件</span>
          </div>
          <el-form-item
            v-if="show.includes('trailerLicenseNo')"
            class="ca-form-item"
            label="车牌照号"
            prop="trailerLicenseNo"
          >
            <span slot="label">
              车牌号
              <i
                v-if="
                  requires.includes('trailerLicenseNo') &&
                  info.vehicleType &&
                  info.vehicleType.includes('挂')
                "
                class="_F36807"
                >*</i
              >
            </span>
            <el-input
              v-model="info['trailerLicenseNo']"
              class="ca-input"
              placeholder="请输入车牌号"
            />
          </el-form-item>
        </template>
        <!-- 道路运输证 -->
        <template v-if="show.includes('transportImage')">
          <div class="ca-form-item-dividing-line"></div>
          <div class="ca-form-item-title">
            <div class="title-bg"></div>
            <span>道路运输证(车头)</span>
          </div>
          <div class="tip" style="margin: -5px 0 5px 0">
            提示：行驶证总质量低于4500KG的4米2以下的车型，不需要填写道运证
          </div>
          <div class="ca-form-item-photos">
            <el-form-item
              v-if="show.includes('transportImage')"
              :required="
                requires.includes('transportImage') &&
                !(info.grossMass > 0 && info.grossMass <= 4500)
              "
              class="ca-form-item-photos-one"
              prop="transportImage"
              @mouseenter.native="handleMouseenter('transportImage')"
              @mouseleave.native="handleMouseLeave"
            >
              <nf-upload-image-new
                ref="transportImageUpload"
                :previewList="previewList"
                :value="info.transportImage"
                imageType="transportImage"
                filePath="vehicle"
                @handleRemove="handleRemove('transportImage')"
                @handleUpload="handleUpload"
              >
                <div class="ca-form-item-photos-label">
                  道路运输证
                  <i
                    v-if="
                      requires.includes('transportImage') &&
                      !(info.grossMass > 0 && info.grossMass <= 4500)
                    "
                    class="_F36807 font_16"
                    >*</i
                  >
                </div>
              </nf-upload-image-new>
            </el-form-item>
            <el-form-item
              v-if="show.includes('transportImageExtra')"
              :required="
                requires.includes('transportImageExtra') &&
                !(info.grossMass > 0 && info.grossMass <= 4500)
              "
              class="ca-form-item-photos-one"
              prop="transportImageExtra"
              @mouseenter.native="handleMouseenter('transportImageExtra')"
              @mouseleave.native="handleMouseLeave"
            >
              <nf-upload-image-new
                ref="transportImageExtraUpload"
                :previewList="previewList"
                :value="info.transportImageExtra"
                imageType="transportImageExtra"
                filePath="vehicle"
                @handleRemove="handleRemove('transportImageExtra')"
                @handleUpload="handleUpload"
              >
                <div class="ca-form-item-photos-label">
                  道路运输证年检页
                  <i
                    v-if="
                      requires.includes('transportImageExtra') &&
                      !(info.grossMass > 0 && info.grossMass <= 4500)
                    "
                    class="_F36807 font_16"
                    >*</i
                  >
                </div>
              </nf-upload-image-new>
            </el-form-item>
            <span class="multiple-text">ctrl+v粘贴证件，支持拖拽上传证件</span>
          </div>
          <el-form-item
            v-if="show.includes('transportNo')"
            class="ca-form-item"
            label="道运证号"
            prop="transportNo"
          >
            <span slot="label">
              道运证号
              <i
                v-if="
                  requires.includes('transportNo') &&
                  !(info.grossMass > 0 && info.grossMass <= 4500)
                "
                class="_F36807"
                >*</i
              >
            </span>
            <el-input v-model="info['transportNo']" class="ca-input" placeholder="请输入道运证号" />
          </el-form-item>
          <el-form-item
            v-if="show.includes('transportOperationNo')"
            class="ca-form-item"
            label="许可证号"
            prop="transportOperationNo"
          >
            <span slot="label">
              许可证号
              <i
                v-if="
                  requires.includes('transportOperationNo') &&
                  !(info.grossMass > 0 && info.grossMass <= 4500)
                "
                class="_F36807"
                >*</i
              >
            </span>
            <el-input
              v-model="info['transportOperationNo']"
              class="ca-input"
              placeholder="请输入许可证号"
            />
          </el-form-item>
          <el-form-item
            v-if="show.includes('merchantName')"
            class="ca-form-item"
            label="业户名称"
            prop="merchantName"
          >
            <span slot="label">
              业户名称
              <i
                v-if="
                  requires.includes('merchantName') &&
                  !(info.grossMass > 0 && info.grossMass <= 4500)
                "
                class="_F36807"
                >*</i
              >
            </span>
            <el-input
              v-model="info['merchantName']"
              class="ca-input"
              placeholder="请输入业户名称"
            />
          </el-form-item>
          <el-form-item
            v-if="show.includes('transportStartDate')"
            class="ca-form-item"
            label="发证日期"
            prop="transportStartDate"
          >
            <span slot="label">
              发证日期
              <i v-if="requires.includes('transportStartDate')" class="_F36807">*</i>
            </span>
            <el-date-picker
              v-model="info['transportStartDate']"
              :picker-options="idEndPicker"
              class="ca-input"
              format="yyyy年MM月dd日"
              placeholder="请选择发证日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>

          <el-form-item
            v-if="show.includes('transportEndDate')"
            class="ca-form-item"
            label="有效期至"
            prop="transportEndDate"
          >
            <span slot="label">
              有效期至
              <i v-if="requires.includes('transportEndDate')" class="_F36807">*</i>
            </span>
            <el-date-picker
              v-model="info['transportEndDate']"
              class="ca-input"
              format="yyyy年MM月dd日"
              placeholder="请选择有效期至"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item
            v-if="show.includes('transportVehicleNo')"
            class="ca-form-item"
            label="车牌号码"
            prop="transportVehicleNo"
          >
            <span slot="label">
              车牌号码
              <i v-if="requires.includes('transportVehicleNo')" class="_F36807">*</i>
            </span>
            <el-input
              v-model="info['transportVehicleNo']"
              class="ca-input"
              placeholder="请输入车牌号码"
            />
          </el-form-item>
        </template>
        <!-- 营运证 -->
        <template v-if="show.includes('licensePhotoExtra')">
          <div class="ca-form-item-dividing-line"></div>
          <div class="ca-form-item-title">
            <div class="title-bg"></div>
            <span>车辆营运证</span>
          </div>
          <div class="ca-form-item-photos">
            <el-form-item
              v-if="show.includes('licensePhotoExtra')"
              :required="requires.includes('licensePhotoExtra')"
              class="ca-form-item-photos-one"
              prop="licensePhotoExtra"
              @mouseenter.native="handleMouseenter('licensePhotoExtra')"
              @mouseleave.native="handleMouseLeave"
            >
              <nf-upload-image-new
                ref="licensePhotoExtraUpload"
                :previewList="previewList"
                :value="info.licensePhotoExtra"
                imageType="licensePhotoExtra"
                filePath="vehicle"
                @handleRemove="handleRemove('licensePhotoExtra')"
                @handleUpload="handleUpload"
              >
                <div class="ca-form-item-photos-label">
                  营运证年检页
                  <i v-if="requires.includes('licensePhotoExtra')" class="_F36807 font_16">*</i>
                </div>
              </nf-upload-image-new>
            </el-form-item>
            <span class="multiple-text">ctrl+v粘贴证件，支持拖拽上传证件</span>
          </div>
          <el-form-item
            v-if="show.includes('periodEndDate')"
            class="ca-form-item"
            label="营运证有效期"
            prop="periodEndDate"
          >
            <span slot="label">
              营运证有效期
              <i v-if="requires.includes('periodEndDate')" class="_F36807">*</i>
            </span>
            <el-input
              v-model="info['periodEndDate']"
              class="ca-input"
              placeholder="请输入营运证有效期"
            />
          </el-form-item>
        </template>
        <!-- 其他 -->
        <template v-if="show.includes('vehicleFrontImage')">
          <div class="ca-form-item-dividing-line"></div>
          <div class="ca-form-item-title">
            <div class="title-bg"></div>
            <span>其他</span>
          </div>
          <div class="ca-form-item-photos">
            <el-form-item
              v-if="show.includes('vehicleFrontImage')"
              :required="requires.includes('vehicleFrontImage')"
              class="ca-form-item-photos-one"
              prop="vehicleFrontImage"
              @mouseenter.native="handleMouseenter('vehicleFrontImage')"
              @mouseleave.native="handleMouseLeave"
            >
              <nf-upload-image-new
                ref="vehicleFrontImageUpload"
                :previewList="previewList"
                :value="info.vehicleFrontImage"
                imageType="vehicleFrontImage"
                filePath="vehicle"
                @handleRemove="handleRemove('vehicleFrontImage')"
                @handleUpload="handleUpload"
              >
                <div class="ca-form-item-photos-label">
                  车头照片
                  <i v-if="requires.includes('vehicleFrontImage')" class="_F36807 font_16">*</i>
                </div>
              </nf-upload-image-new>
            </el-form-item>
            <span class="multiple-text">ctrl+v粘贴证件，支持拖拽上传证件</span>
          </div>
        </template>
        <div v-if="from === 'detail'" class="ca-form-item-dividing-line"></div>
        <div v-if="show.includes('driverIds') && from === 'detail'" class="ca-form-item-title">
          <div class="title-bg"></div>
          <span>绑定司机</span>
        </div>
        <el-form-item
          v-if="show.includes('driverIds') && from === 'detail'"
          class="ca-form-item1"
          label="绑定司机"
          prop="driverIds"
        >
          <div
            v-for="(item, index) in info.driverList"
            :key="index"
            class="flexCon font_14 justify_space ca-input pointer"
            style="line-height: 28px; padding-bottom: 12px"
          >
            <span class="font_500">
              {{ item.name }}：
              <span class="_666666 font_400">
                {{ item.mobile }}
              </span>
            </span>
            <span
              class="_F36807"
              style="line-height: 28px; width: 60px; text-align: center"
              @click="handleUnBangding(item.id)"
            >
              解绑
            </span>
          </div>
          <label class="flex ca-input">
            <el-autocomplete
              v-model="driverName"
              :debounce="0"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              class="ca-input"
              placeholder="请输入司机姓名或手机号"
              size="mini"
              style="width: 218px; margin: 5px 0 0 0; display: inline-block"
              value-key="name"
              @select="handleSelect"
            >
              <template slot-scope="{ item }">
                <el-tooltip
                  :content="item.name + ' ' + item.mobile"
                  class="item"
                  effect="dark"
                  placement="right"
                >
                  <div class="flexCon justify_space">
                    <span>
                      {{ item.name }}
                    </span>
                    <span class="_999999">
                      {{ item.mobile }}
                    </span>
                  </div>
                </el-tooltip>
              </template>
            </el-autocomplete>
            <span
              :class="!checkDriver.id ? ' allowed _999999 ' : ' pointer _445EBF '"
              class="font_14 margin-l-10 inline_block"
              style="width: 60px; line-height: 28px"
              @click="checkDriver.id ? handBangDingdriver() : null"
            >
              绑定
            </span>
          </label>
        </el-form-item>
      </template>
      <!-- 自有 -->
      <!-- <template v-if="info['vehicleProperty'] === 'own'">
        <el-form-item class="ca-form-item" label="轴数" prop="shaftNumber">
          <span slot="label">
            轴数
            <i class="_F36807">*</i>
          </span>
          <el-select
            v-model="info['shaftNumber']"
            class="ca-input"
            placeholder="请选择轴数"
            @change="handleChange($event, 'shaftNumber')"
          >
            <template v-for="shaft in 99">
              <el-option v-if="shaft > 1" :key="shaft" :label="shaft" :value="shaft"
                >{{ shaft }}
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item class="ca-form-item ca-form-item-100" label="车牌颜色" prop="vehicleColor">
          <span slot="label">
            车牌颜色
            <i v-if="requires.includes('vehicleColor')" class="_F36807">*</i>
          </span>
          <el-radio-group v-model="info['vehicleColor']">
            <el-radio label="黄色" />
            <el-radio label="黄绿色" />
            <el-radio label="蓝色" />
            <el-radio label="渐变绿色" />
          </el-radio-group>
        </el-form-item>
        <el-form-item class="ca-form-item" label="车长" prop="vehicleLength" required>
          <span slot="label">
            车长
            <i class="_F36807">*</i>
          </span>
          <el-select
            v-model="info['vehicleLength']"
            class="ca-input"
            placeholder="请选择车长"
            @change="handleChange($event, 'vehicleLength')"
          >
            <template v-for="vehicleLength in vehicleLengthList">
              <el-option :key="vehicleLength" :label="vehicleLength" :value="vehicleLength"
                >{{ vehicleLength }}
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="info.shaftNumber === 2"
          class="ca-form-item"
          label="总质量"
          prop="grossMass"
        >
          <span slot="label">
            总质量
            <i class="_F36807">*</i>
          </span>
          <el-input v-model="info['grossMass']" class="ca-input" placeholder="输入总质量">
            <template slot="append"> kg</template>
          </el-input>
        </el-form-item>
        <el-form-item class="ca-form-item" label="能源类型" prop="fuelType">
          <span slot="label">
            能源类型
            <i class="_F36807">*</i>
          </span>
          <el-radio-group v-model="info['fuelType']" class="ca-input">
            <el-radio label="柴油" />
            <el-radio label="天然气" />
            <el-radio label="汽油" />
          </el-radio-group>
        </el-form-item>
        <el-form-item class="ca-form-item" label="载货长度" prop="carryCargoLength">
          <span slot="label"> 载货长度 </span>
          <el-select
            v-model="info['carryCargoLength']"
            class="ca-input"
            filterable
            clearable
            placeholder="请选择载货长度"
          >
            <el-option
              v-for="even in extent"
              :key="even.value"
              :label="even.label | filterExtent"
              :value="even.value"
            >
              {{ even.label }} 米
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="info.fuelType != '天然气'"
          class="ca-form-item"
          label="载重油耗"
          prop="oilWear"
        >
          <span slot="label">
            载重油耗
            <i class="_F36807">*</i>
          </span>
          <el-input v-model.number="info['oilWear']" class="ca-input" placeholder="载重油耗">
            <template slot="append">L/100KM</template>
          </el-input>
        </el-form-item>
        <el-form-item class="ca-form-item" label="关联司机" prop="driverId">
          <label class="flex ca-input">
            <el-autocomplete
              v-model="driverName"
              :debounce="0"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              class="ca-input"
              placeholder="请输入司机姓名或手机号"
              size="mini"
              style="width: 218px; margin: 5px 0 0 0; display: inline-block"
              value-key="name"
              @select="handleSelect"
            >
              <template slot-scope="{ item }">
                <el-tooltip
                  :content="item.name + ' ' + item.mobile"
                  class="item"
                  effect="dark"
                  placement="right"
                >
                  <div class="flexCon justify_space">
                    <span>
                      {{ item.name }}
                    </span>
                    <span class="_999999">
                      {{ item.mobile }}
                    </span>
                  </div>
                </el-tooltip>
              </template>
            </el-autocomplete>
          </label>
        </el-form-item>
        <div class="ca-form-item-dividing-line"></div>
        <div class="ca-form-item-title">
          <div class="title-bg"></div>
          设备信息
        </div>
        <el-form-item class="ca-form-item" label="ETC卡号" prop="etcNumber">
          <el-input
            v-model.number="info['etcNumber']"
            :disabled="info.etcDisabled"
            class="ca-input"
            placeholder="输入ETC卡号"
          />
        </el-form-item>
        <el-form-item class="ca-form-item" label="etc发卡方" prop="etcIssuer">
          <span slot="label"> etc发卡方 </span>
          <el-select
            v-model="info['etcIssuer']"
            :disabled="info.etcDisabled"
            class="ca-input"
            placeholder="请选择etc发卡方"
            @change="handleChange($event, 'etcIssuer')"
          >
            <template v-for="etc in etcList">
              <el-option :key="etc" :label="etc.label" :value="etc.value"
                >{{ etc.label }}
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item class="ca-form-item" label="GPS设备号" prop="gpsNumber">
          <el-input v-model.number="info['gpsNumber']" class="ca-input" placeholder="GPS设备号" />
        </el-form-item>
        <div class="ca-form-item-dividing-line"></div>
        <template v-if="info && info.id">
          <div class="ca-form-item-title">
            <div class="title-bg"></div>
            日志
          </div>
          <el-form-item class="ca-form-item" label="创建人">
            <span slot="label"> 创建人 </span>
            <div class="ca-input _999999 font_14 padding-l-20">{{ info['creatorName'] }}</div>
          </el-form-item>
          <el-form-item class="ca-form-item" label="创建时间">
            <span slot="label"> 创建时间 </span>
            <div class="ca-input _999999 font_14 padding-l-20">{{ info['createTime'] }}</div>
          </el-form-item>
        </template>
      </template> -->
    </template>
    <SettleAccounts
      :data="wrapFormDataSettle"
      :info="info"
      :show="settleShow"
      @handClose="handSettleClose"
      @handShow="handSettleShow"
    />
  </el-form>
</template>

<script>
import {
  pageCollectInfo,
  getVehicleList,
  getConvoyListByPage,
  getDriverList,
  bindVehicle,
  driverBindCar,
  unBindCar,
  driverBindList,
  setDefaultCar,
  postBindDriverVehiclePicture,
} from '@/api/capacity';
import moment from 'moment';
import nfUploadImage from '@/components/nf-upload-image';
import SettleAccounts from '@/components/nf-settle/index';
import { rules } from '@/components/nf-capacity/rules';
import { getEnum } from '@/api/getEnum';
import etcList from '@/utils/etcList';
import { extent } from '@/utils/dictionary/index';
import { imageCompress } from '@/utils/compress';
import { changeImg } from '@/utils';

export default {
  name: 'nfCapacity',
  components: {
    nfUploadImage,
    SettleAccounts,
  },
  props: {
    type: {
      type: String,
      default: 'driver',
    },
    driverProperty: {
      type: String,
      default: 'transfer',
    },
    from: {
      type: String,
      default: 'detail',
    },
    capacityInfo: {
      type: Object,
      default: () => {},
    },
    info: {
      type: Object,
      default: () => {},
    },
    requires: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    requires: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          console.log(this.type);
          for (const valKey in this.rules) {
            if (this.type === 'vehicle') {
              if (
                [
                  'transportImage',
                  'transportImageExtra',
                  'transportNo',
                  'transportOperationNo',
                  'merchantName',
                ].includes(valKey)
              ) {
                this.rules[valKey][0].require =
                  this.requires.includes(valKey) &&
                  !(this.info.grossMass > 0 && this.info.grossMass <= 4500);
              } else if (!['shaftNumber', 'oilWear'].includes(valKey)) {
                this.rules[valKey][0].require = this.requires.includes(valKey);
              }
            } else {
              this.rules[valKey][0].require = this.requires.includes(valKey);
            }
          }
        }
      },
    },
    'info.vehicleType': {
      deep: true,
      handler(val, old) {
        console.log(333, val);
        if (!(this.type === 'vehicle')) {
          return;
        }
        if (val === old || !val) {
          return;
        }
        const flag = val.includes('挂');
        console.log(flag);
        ['trailerLicenseOriginalImage', 'trailerLicenseDeputyImage', 'trailerLicenseNo'].forEach(
          valKey => {
            console.log(valKey, this.rules[valKey][0]);
            this.rules[valKey][0].require = this.requires.includes(valKey) && flag;
            console.log(valKey, this.rules[valKey][0]);
          },
        );
      },
    },
    'info.vehicleProperty': {
      deep: true,
      handler(val) {
        if (!(this.type === 'vehicle')) {
          return;
        }
        if (val) {
          if (val === 'own') {
            if (this.info.shaftNumber === 0) {
              this.info.shaftNumber = 2;
            }
            this.rules['grossMass'][0].require = true;
          } else {
            this.rules['grossMass'][0].require = false;
          }
          this.$refs['form'].clearValidate();
        }
      },
    },
    'info.grossMass': {
      deep: true,
      handler(val, old) {
        if (!(this.type === 'vehicle')) {
          return;
        }
        if (val === old || !val) {
          return;
        }
        this.info.grossMass = val.toString().match(/^\d*(\.?\d{0,2})/g)[0];
        if (Number(val) > 999999.99) {
          this.info.grossMass = 999999.99;
        }
        [
          'transportImage',
          'transportImageExtra',
          'transportNo',
          'transportOperationNo',
          'merchantName',
        ].forEach(valKey => {
          this.rules[valKey][0].require =
            this.requires.includes(valKey) && !(val > 0 && val <= 4500);
        });
      },
    },
    'info.approverLoad': {
      deep: true,
      handler(val, old) {
        if (!(this.type === 'vehicle')) {
          return;
        }
        if (val === old || !val) {
          return;
        }
        this.info.approverLoad = val.toString().match(/^\d*(\.?\d{0,2})/g)[0];
        if (Number(val) > 999999.99) {
          this.info.approverLoad = 999999.99;
        }
      },
    },
    'info.totalTractionMass': {
      deep: true,
      handler(val, old) {
        if (!(this.type === 'vehicle')) {
          return;
        }
        if (val === old || !val) {
          return;
        }
        this.info.grostotalTractionMasssMass = val.toString().match(/^\d*(\.?\d{0,2})/g)[0];
        if (Number(val) > 999999.99) {
          this.info.totalTractionMass = 999999.99;
        }
      },
    },
    'info.curbWeight': {
      deep: true,
      handler(val, old) {
        if (!(this.type === 'vehicle')) {
          return;
        }
        if (val === old || !val) {
          return;
        }
        this.info.curbWeight = val.toString().match(/^\d*(\.?\d{0,2})/g)[0];
        if (Number(val) > 999999.99) {
          this.info.curbWeight = 999999.99;
        }
      },
    },
    'info.oilWear': {
      deep: true,
      handler(val, old) {
        if (!(this.type === 'vehicle')) {
          return;
        }
        if (val === old || !val) {
          return;
        }
        this.info.curbWeight = val.toString().match(/^\d*(\.?\d{0,2})/g)[0];
        if (Number(val) > 999.99) {
          this.info.curbWeight = 999.99;
        }
      },
    },
    'info.id': {
      handler(val) {
        if (val && this.type == 'driver') {
          this.getBIndCarList();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  data() {
    return {
      rules: rules,
      convoyList: [],
      collectList: [],
      vehicleTypeList: [],
      VehicleModelList: [],
      vehicleLengthList: [
        4.5, 6.2, 6.8, 7.2, 7.7, 8.2, 8.7, 9.6, 10, 12, 12.5, 13, 13.5, 15, 16, 17.5, 19, 20, 21,
      ],
      etcList: etcList,
      settleShow: false,
      wrapFormDataSettle: '',
      driverName: '',
      checkDriver: '',
      accept: '.jpg,.jpeg,.png', // 限制证件类型
      extent,
      carList: [],
      value: '', // 司机绑定值
      carValue: '', // 车辆绑定值
      carObj: {},
      driverId: 0,
      imageTypeActive: '', // 粘贴上传的图片
      pickerOptions: {
        disabledDate: time => {
          // 设置最小选择日期为今天
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 设置时间为00:00:00
          return time.getTime() < today.getTime(); // 返回true表示该日期不可选
        },
      },
      changeImg,
    };
  },
  computed: {
    idtransportEndDatePicker() {
      return {
        disabledDate: time => {
          return this.info.transportEndDate
            ? moment(time).valueOf() > moment(this.info.transportEndDate).valueOf()
            : '';
        },
      };
    },
    idStartPicker() {
      return {
        disabledDate: time => {
          return this.info.identityValidityEnd
            ? moment(time).valueOf() > moment(this.info.identityValidityEnd).valueOf()
            : '';
        },
      };
    },
    idEndPicker() {
      return {
        disabledDate: time => {
          return this.info.identityValidityStart
            ? moment(time).valueOf() < moment(this.info.identityValidityStart).valueOf()
            : '';
        },
      };
    },
    driverStartPicker() {
      return {
        disabledDate: time => {
          return this.info.driverLicenseValidityEnd
            ? moment(time).valueOf() > moment(this.info.driverLicenseValidityEnd).valueOf()
            : '';
        },
      };
    },
    driverEndPicker() {
      return {
        disabledDate: time => {
          return this.info.driverLicenseValidityStart
            ? moment(time).valueOf() < moment(this.info.driverLicenseValidityStart).valueOf()
            : '';
        },
      };
    },
    previewList() {
      const list = [];
      for (const item in this.info) {
        if ((item.includes('Image') || item.includes('Photos')) && this.info[item]) {
          console.log('previewList', this.info[item]);
          list.push(this.changeImg(this.info[item]));
        }
      }
      return list;
    },
    whetherUpdateWaybill() {
      return this.$store.state.waybill.whetherUpdateWaybill;
    },
  },
  created() {
    if (this.type === 'vehicle') {
      for (const valKey in this.rules) {
        if (
          [
            'transportImage',
            'transportImageExtra',
            'transportNo',
            'transportOperationNo',
            'merchantName',
          ].includes(valKey)
        ) {
          this.rules[valKey][0].require =
            this.requires.includes(valKey) &&
            !(this.info.grossMass > 0 && this.info.grossMass <= 4500);
        } else if (!['shaftNumber', 'oilWear'].includes(valKey)) {
          this.rules[valKey][0].require = this.requires.includes(valKey);
        }
      }
      this.rules['grossMass'][0].require = this.info.vehicleProperty === 'own';
      this.getVehicleTypeEnum();
      this.getVehicleModelEnum();
    } else {
      for (const valKey in this.rules) {
        this.rules[valKey][0].require = this.requires.includes(valKey);
      }
      if (this.info.collectInfoId && this.show.includes('collectInfoId')) {
        pageCollectInfo({ payeeName: '' }).then(res => {
          this.collectList = res.data.records;
          this.$forceUpdate();
        });
      }
      if (this.info.convoyInfoId && this.show.includes('convoyInfoId')) {
        this.onConvoyFilter();
      }
    }
  },

  methods: {
    // 车队查询
    async onConvoyFilter(param) {
      if (param) {
        this.convoyList = [];
      }
      const { code, data } = await getConvoyListByPage({
        name: param,
        page: 1,
        size: 300,
      });
      if (code === 200) {
        this.convoyList = data;
      }
      this.$forceUpdate();
    },
    // 车队下拉
    onConvoyVisible(val) {
      if (val) {
        this.onConvoyFilter();
      }
    },
    // 上传成功回调
    handleUpload(data) {
      this.$emit('handleChange', data);
    },
    // 图片移除
    handleRemove(code) {
      this.info[code] = '';
    },
    // 模糊搜索 搜到了哪些数据
    async querySearch(queryString, callback) {
      const _this = this;
      let res = {},
        anyData = [];
      if (queryString) {
        if (_this.type === 'driver') {
          res = await getVehicleList({
            vehicleProperty: _this.info.driverProperty,
            vehicleNo: queryString,
            page: 1,
            size: 10,
          });
          res.data.list &&
            res.data.list.forEach(item => {
              anyData.push({
                name: item.vehicleNo,
                id: item.id,
                vehicleType: item.vehicleType ? item.vehicleType : '',
                vehicleColor: item.vehicleColor,
              });
            });
        } else if (_this.type === 'vehicle') {
          res = await getDriverList({
            driverProperty: _this.info.vehicleProperty === 'own' ? 'own' : 'transfer',
            name: queryString,
            page: 1,
            size: 10,
          });
          anyData = res.data.list && res.data.list;
        }
        const results = queryString
          ? anyData.filter(queryString => {
              return anyData => {
                return anyData.name.indexOf(queryString);
              };
            })
          : anyData;
        callback(results);
      }
    },
    // 模糊搜索 选择了哪个
    handleSelect(val) {
      if (this.type === 'driver') {
        this.info.vehicleColor = val.vehicleColor;
        this.info.vehicleNo = val.name;
        this.carObj = val ? val : {};
      }
      if (this.type === 'vehicle') {
        if (this.info.vehicleProperty === 'own') {
          this.info.driverId = val.id;
          this.info.driverInfoDto = val;
          return;
        }
        this.checkDriver = val;
      }
    },
    onCaptainRemoteMethod1(query) {
      pageCollectInfo({ payeeName: query }).then(res => {
        this.collectList = res.data.records;
        this.$forceUpdate();
      });
    },
    onCaptainVisible1() {
      pageCollectInfo({ payeeName: '' }).then(res => {
        this.collectList = res.data.records;
        this.$forceUpdate();
      });
    },
    // 编辑司机结算信息
    handleDriverBank() {
      const { name, identityNumber, identityPositiveImage, identityReverseImage } = this.info;
      if (
        name != '' &&
        name &&
        identityNumber != '' &&
        identityNumber &&
        identityPositiveImage != '' &&
        identityPositiveImage &&
        identityReverseImage != '' &&
        identityReverseImage
      ) {
        this.wrapFormDataSettle = this.info;
        this.settleShow = true;
      } else {
        this.$$message('请先完善身份证信息', 'error');
      }
    },
    // 编辑结算信息弹窗保存按钮
    handSettleShow(val) {
      this.settleShow = false;
      this.info.bankCard = val.bankCard;
      this.info.supBank = val.supBank;
      this.info.bank = val.bank;
      this.info.bankCardPhone = val.bankCardPhone;
    },
    // 编辑结算信息弹窗关闭按钮
    handSettleClose() {
      this.settleShow = false;
    },
    // 车辆类型枚举
    async getVehicleTypeEnum() {
      const { data } = await getEnum({
        UIEnumType: 'VehicleType',
      });
      const obj = [];
      data.forEach(item => {
        obj.push({ label: item, value: item });
      });
      this.vehicleTypeList = obj;
    },
    // 车辆类型枚举
    async getVehicleModelEnum() {
      const { data } = await getEnum({
        UIEnumType: 'VehicleModel',
      });
      const obj = [];
      data.forEach(item => {
        obj.push({ label: item, value: item });
      });
      this.VehicleModelList = obj;
    },
    handCaptainClear() {
      this.info.collectInfoId = '';
      this.info.collectInfoDto = '';
      this.$set(this.info, 'collectInfoId', '');
      this.$set(this.info, 'collectInfoDto', '');
    },
    handleDriverProperty() {
      if (this.type === 'driver') {
        this.info.vehicleNo = '';
        this.info.vehicleColor = '';
      }
      this.$forceUpdate();
    },
    handleChange(e, code) {
      if (e) {
        if (this.type === 'driver') {
          if (code === 'driverProperty') {
            this.info.vehicleNo = '';
            this.info.vehicleColor = '';
          }
          if (code === 'convoyInfoId') {
            const convoyInfo = this.convoyList.filter(item => {
              return Number(item.id) === e;
            });
            this.info.convoyInfoDto = convoyInfo[0];
            this.info.convoyInfoId = e;
          }
          if (code === 'collectInfoId') {
            const collectInfo = this.collectList.filter(item => {
              return Number(item.id) === e;
            });
            this.info.collectInfoDto = collectInfo[0];
            this.info.collectInfoId = e;
          }
        }
        if (this.type === 'vehicle') {
          if (code === 'vehicleProperty') {
            this.info.driverId = '';
            this.info.driverInfoDto = {};
            this.info.driverIds = [];
            this.info.driverList = [];
          }
        }
      }
    },
    // 绑定
    handBangDingdriver() {
      let arr = false;

      if (!this.checkDriver.id) {
        this.$$message('请选择绑定的司机', 'error');
      } else {
        arr =
          this.info.driverList &&
          this.info.driverList.length > 0 &&
          this.info.driverList.some(item => item.id == this.checkDriver.id);
        if (arr === true) {
          this.$$message('已绑定过该司机', 'error');
          this.checkDriver = {};
        } else {
          bindVehicle(
            Object.assign(
              {},
              {
                vehicleNo: this.info.vehicleNo,
                vehicleColor: this.info.vehicleColor,
                mobile: this.checkDriver.mobile,
              },
            ),
          ).then(res => {
            if (res.code === 200) {
              this.info.driverIds = [...new Set(this.info.driverIds.concat([this.checkDriver.id]))];
              this.info.driverList = [...new Set(this.info.driverList.concat([this.checkDriver]))];
              this.$emit('handleChange', this.info);
              this.driverName = '';
              this.checkDriver = {};
            }
          });
        }
      }
    },
    // // 解绑
    async handleUnBangding(val) {
      this.info.driverIds.splice(
        this.info.driverIds.findIndex(item => Number(item) === Number(val)),
        1,
      );
      this.info.driverList.splice(
        this.info.driverList.findIndex(item => item.id === val),
        1,
      );
      const { code, message } = await unBindCar({
        vehicleInfoId: this.info.id,
        driverInfoId: val,
      });
      if (code == 200) {
        this.$$message(message, 'success');
      }
    },
    async getBIndCarList() {
      const res = await driverBindList({ driverInfoId: this.info.id });
      this.carList = res.data.bindList;
    },
    // 绑定车辆
    handBangDingCar() {
      let arr = false;
      if (JSON.stringify(this.carObj) === '{}') {
        this.$$message('请选择绑定的车辆', 'error');
      } else {
        arr = this.carList && this.carList.some(item => item.vehicleInfoId == this.carObj.id);
        if (arr == true) {
          this.$$message('已绑定过改车辆', 'error');
          this.carObj = {};
        } else {
          this.handleBindCar(this.carObj.id);
        }
      }
    },
    //绑定车辆
    async handleBindCar(id) {
      const { message, code } = await driverBindCar({
        vehicleInfoId: id,
        driverInfoId: this.info.id,
      });
      if (code == 200) {
        this.$$message(message, 'success');
        this.carValue = '';
        this.carObj = {};
        this.getBIndCarList();
      }
    },
    //解除绑定车辆
    async handleUnBandCar(id) {
      const { code, message } = await unBindCar({
        vehicleInfoId: id,
        driverInfoId: this.info.id,
      });
      if (code == 200) {
        this.$$message(message, 'success');
        this.getBIndCarList();
      }
    },
    // 上传人车合照
    handleUploadImage(file, carInfo) {
      const _this = this;
      _this.showLoad = true;
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          groupId: window.localStorage.userInfo
            ? JSON.parse(window.localStorage.userInfo).groupId
            : '',
        },
      };
      imageCompress(file.raw).then(newFile => {
        const formData = new FormData();
        formData.append('file', newFile);
        formData.append('module', 'driverVehiclePicture');
        // 上传图片
        _this.$http
          .post('/rest/upload/v3/uploadFile', formData, config)
          .then(res => {
            if (res.code === 200) {
              _this.bindDriverVehiclePicture({
                driverInfoId: _this.info.id,
                vehicleInfoId: carInfo.vehicleInfoId,
                driverVehiclePicture: res.data,
              });
            } else {
              setTimeout(() => {
                _this.showLoad = false;
              }, 500);
            }
          })
          .catch(() => {
            _this.showLoad = false;
          });
      });
    },
    // 人&车&合照绑定
    async bindDriverVehiclePicture(carInfo) {
      const { code } = await postBindDriverVehiclePicture(carInfo);
      if (code === 200) {
        this.showLoad = false;
        this.getBIndCarList();
      }
    },
    //设为默认
    async setCarDefault(id) {
      const arr = this.carList.filter(item => {
        return item.vehicleInfoId == id;
      });

      const { code, message } = await setDefaultCar({
        vehicleInfoId: id,
        driverInfoId: this.info.id,
      });
      if (code == 200) {
        this.info.vehicleNo = arr && arr[0].vehicleNo;
        this.info.vehicleColor = arr && arr[0].vehicleColor;
        this.$$message(message, 'success');
        this.getBIndCarList();
      }
    },
    // 图片粘贴 只支持command+v/ctrl+v
    handlePaste(e) {
      if (this.imageTypeActive) {
        const arr = (e.clipboardData || window.clipboardData).items,
          fileList = [];
        let bool = false;
        if (!arr || arr.length === 0) {
          this.$message.warning('当前浏览器不支持粘贴图片上传！');
          return;
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].type.indexOf('image') !== -1) {
            bool = true;
            fileList.push(arr[i].getAsFile());
          } else {
            bool = false;
          }
        }
        if (!fileList.length) {
          this.$message.warning('粘贴内容非图片！');
        }
        if (fileList.length > 1) {
          this.$message.warning('只能粘贴一张图片！');
        }
        if (bool) {
          fileList.forEach(file => {
            this.$refs[`${this.imageTypeActive}Upload`].compressionPicture(file, 5000).then(res => {
              this.$refs[`${this.imageTypeActive}Upload`].imageUpload(res);
            });
          });
        }
      }
    },
    handleMouseenter(imageType) {
      this.imageTypeActive = imageType;
    },
    handleMouseLeave() {
      this.imageTypeActive = '';
    },
  },
  // 复制 粘贴图片
  mounted() {
    window.addEventListener('paste', this.handlePaste, true);
    const that = this;
    window.onresize = () => {
      return (() => {
        window.fullHeight =
          document.documentElement.clientHeight - document.documentElement.clientHeight * 0.2 - 155;
        that.fullHeight = window.fullHeight;
      })();
    };
    document.ondragover = function (e) {
      e.preventDefault(); //阻止拖放的图片在新窗口中直接显示,拖放的目标对象此时是document对象
    };
    document.ondrop = function (e) {
      e.preventDefault(); //阻止 document.ondrop的默认行为  *** 在新窗口中打开拖进的图片
    };
  },
  // 复制 粘贴图片
  destroyed() {
    window.removeEventListener('paste', this.handlePaste, true);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border-color: #ffffff;
}

::v-deep .el-input__inner:hover {
  border-color: #445ebf;
}

::v-deep .el-input__inner:focus {
  border-color: #445ebf;
}

::v-deep .el-input-group__append {
  background: #fff !important;
  border-color: #fff !important;
}
.ca-form {
  height: 100%;

  .ca-form-item {
    ::v-deep .el-form-item__label {
      white-space: nowrap !important;
    }

    .ca-input {
      width: 190px !important;
      margin-top: 0 !important;

      ::v-deep .el-radio {
        margin-right: 15px;
      }
    }

    .ca-radio {
      width: 300px;
    }
  }
  .ca-form-item1 {
    width: 500px;
    .ca-input {
      width: 300px !important;
      margin-top: 0 !important;
    }
  }

  .ca-form-item-100 {
    width: 100%;
  }

  .ca-form-item-dividing-line {
    width: 100%;
    height: 1px;
    background-color: #eaebef;
    margin: -5px 0 15px;
  }

  .ca-form-item-title {
    height: 40px;
    line-height: 40px;
    display: flex;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC, serif;
    font-weight: 500;
    color: #181818;

    .title-bg {
      display: inline-block;
      width: 5px;
      height: 20px;
      margin-top: 10px;
      background-color: #445ebf;
      border-radius: 5px;
      margin-right: 10px;
    }
  }

  .ca-form-item-photos {
    display: flex;
    align-items: flex-end;
    margin-bottom: 18px;

    .ca-form-item-photos-one {
      margin-bottom: 0px;
    }

    .ca-form-item-photos-label {
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      color: #333333;
    }
  }

  .set-vehicleNo {
    display: inline-block;
    width: 110px;
  }
  .unset-default {
    display: inline-block;
    width: 40px;
    margin-left: 20px;
    color: #f36807;
  }
  .set-default {
    display: inline-block;
    height: 18px;
    padding: 0 4px;
    background: #ffeded;
    border-radius: 2px;
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #f55a5a;
    text-align: center;
    line-height: 18px;
    margin-top: 6px;
  }
  ._445EBF {
    color: #445ebf;
  }
}

.ca-form-item-photos {
  ::v-deep .el-form-item__error {
    width: 100%;
    text-align: center;
  }
}
.avatar-uploader {
  margin: 0 25px;
  ::v-deep .el-upload {
    width: 94px;
    height: 66px;
    flex-wrap: wrap;

    .avatar-uploader-icon {
      flex: 200px;
    }
  }
  ::v-deep .actions-btn {
    font-size: 20px;
    color: #8c939d;
    &-item {
      margin: 0 5px;
    }
  }
}
.tip {
  color: red;
  font-size: 12px;
  margin-left: 10px;
  font-weight: normal;
}
</style>
